import axios from 'axios'
import qs from 'qs'

const client = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL ?? '/api/v1',
  headers: {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
  withXSRFToken: true,
  paramsSerializer: {
    serialize: (params) => qs.stringify(params, { arrayFormat: 'brackets', skipNulls: true }),
  },
})

export default client
